import { useQuery } from 'react-query';
import { useAPI } from '@axo/shared/data-access/provider';
import { real_estate_api } from '@axo/shared/data-access/api';
import { realEstateKeys } from '../../cache-keys/realEstateKeys';

export function useGetApplicationCollateral({
  applicationID,
}: {
  applicationID?: string;
}) {
  const api = useAPI();

  return useQuery({
    queryKey: [realEstateKeys.applicationCollateral({ applicationID })],
    queryFn: ({ queryKey: [{ applicationID }] }) =>
      real_estate_api.getLoanApplicationCollateral(api)({
        applicationID: applicationID ?? '',
      }),
    enabled: api.token.length > 0 && !!applicationID,
  });
}
